(function () {
  'use strict';
  function activateWidth(details, width) {
    details.querySelectorAll('[data-cc-width-tab]').forEach(function (tab) {
      tab.setAttribute('aria-pressed', String(tab.dataset.ccWidthTab === width));
    });
    details.querySelectorAll('.cc-card-quickshop__size').forEach(function (label) {
      var hide = label.dataset.ccFitWidth !== width;
      label.hidden = hide;
      if (hide) {
        var input = label.querySelector('input');
        if (input) input.checked = false;
      }
    });
  }
  function init(root) {
    (root || document).querySelectorAll('.cc-card-quickshop').forEach(function (details) {
      if (details.dataset.ccWidthTabsReady) return;
      details.dataset.ccWidthTabsReady = '1';
      var tabs = details.querySelectorAll('[data-cc-width-tab]');
      if (!tabs.length) return;
      activateWidth(details, tabs[0].dataset.ccWidthTab);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateWidth(details, tab.dataset.ccWidthTab);
        });
      });
    });
  }
  function start() {
    init(document);
    var grid = document.getElementById('product-grid');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { init(grid); }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();